module.exports = __webpack_public_path__ + "43ffa7d4082f366dc57c7024548aa897.png";